<template>
  <div class="image-slider">
    <div class="slider-container">
      <div
        class="slider-wrapper"
        :class="[`image-${imageSize}`, { 'no-transition': noTransition }]"
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
        @transitionend="handleTransitionEnd"
      >
        <div
          v-for="(image, index) in slides"
          :key="index"
          class="slide"
        >
          <img
            v-if="image"
            :src="addCdnImageWidth(image, imageSize === 'large' ? 900 : 600)"
            alt="Slider Image"
            class="slider-image"
            @error="autoplay ? removeBrokenImage(realIndex(index)) : setPlaceHolderImage(realIndex(index))"
          >
        </div>
      </div>
      <div
        v-if="controls && images.length > 1"
        class="controls"
      >
        <b-icon 
          class="control-arrow" 
          icon="arrow-left-circle" 
          @click="prevImage()"
        />
        <b-icon 
          class="control-arrow" 
          icon="arrow-right-circle" 
          @click="nextImage()"
        />
      </div>
    </div>
  </div>
</template>
  
<script>
import placeHolder from '../images/image-placeholder.png'
import { addCdnImageWidth } from '@/lib/utilities'
export default {
  props: {
    images: {
      type: Array
    },
    autoplay: {
      type: Boolean,
    },
    controls: {
      type: Boolean
    },
    imageSize: {
      type: String
    }
  },
  data() {
    return {
      currentIndex: 0,
      noTransition: false,
      timer: null,
      placeHolder
    }
  },
  computed: {
    // Clone the last slide before the first and the first slide after the
    // last, so next/prev can keep moving in one direction at the ends -
    // handleTransitionEnd then snaps back to the matching real slide.
    slides() {
      if (this.images.length <= 1) return this.images
      return [this.images[this.images.length - 1], ...this.images, this.images[0]]
    }
  },
  watch: {
    images () {
      this.currentIndex = this.images.length > 1 ? 1 : 0
    }
  },
  mounted() {
    this.currentIndex = this.images.length > 1 ? 1 : 0
    if (this.autoplay) {
      this.startSlider()
    }
  },
  beforeDestroy() {
    this.stopSlider()
  },
  methods: {
    addCdnImageWidth,
    startSlider() {
      this.timer = setInterval(() => {
        this.nextImage()
      }, 5000)
    },
    stopSlider() {
      clearInterval(this.timer)
    },
    nextImage() {
      if (this.images.length <= 1) return
      this.currentIndex++
    },
    prevImage() {
      if (this.images.length <= 1) return
      this.currentIndex--
    },
    // Once the transition onto a cloned end-slide finishes, jump to the
    // matching real slide with the transition disabled so the loop reads
    // as continuous instead of snapping back to the start.
    handleTransitionEnd() {
      if (this.currentIndex === this.slides.length - 1) {
        this.jumpTo(1)
      } else if (this.currentIndex === 0) {
        this.jumpTo(this.slides.length - 2)
      }
    },
    jumpTo(index) {
      this.noTransition = true
      this.currentIndex = index
      this.$nextTick(() => {
        // Force a reflow so the transition-less jump is committed before
        // transitions are re-enabled for the next click.
        void this.$el.offsetHeight
        this.noTransition = false
      })
    },
    // Maps a position in the rendered (cloned) slide list back to the
    // real index in the `images` prop, for error/placeholder handling.
    realIndex(slideIndex) {
      if (this.images.length <= 1) return slideIndex
      if (slideIndex === 0) return this.images.length - 1
      if (slideIndex === this.slides.length - 1) return 0
      return slideIndex - 1
    },
    // If autoplay is enabled we will want to just get rid of the broken image from the slide show
    removeBrokenImage (index) {
      this.images.splice(index, 1)
    },
    // If autoplay isnt enabled we will need a place holder image
    setPlaceHolderImage (index) {
      this.images[index] = 'https://cdn.trailfinders.com/image-placeholder.png'
      // Re render ui so placeholder image displays
      // If we dont do this the ui wont have the updated image
      this.$forceUpdate()
    }
  }
};
</script>
  
<style lang="scss">
.image-slider {
  max-width: 100%;
  overflow: hidden;
  position: relative;
}
.slider-container {
  position: relative;
  height: 100%;
  overflow: hidden;
}  
.slider-wrapper {
  display: flex;
  transition: transform 0.5s ease;
}
.slider-wrapper.no-transition {
  transition: none;
}
.slide {
  flex: 0 0 100%;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}
.slide img {
  height: 100%;
}
.slide-enter-active,
.slide-leave-active {
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}
.slide-enter {
  animation-name: slideInRight;
}
.slide-leave-to {
  animation-name: slideOutLeft;
}
@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}  
@keyframes slideOutLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}  
img {
  width: 100%;
  height: auto;
  display: block;
}
.controls {
  position: absolute;
  top: 50%;
  color: white;
  z-index: 100;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px 0 20px;
}
.control-arrow {
  font-size: 50px;
  cursor: pointer;
}
.image-standard {
  height: 325px;
}
.image-large {
  height: 450px;
}
.slider-image {
  height: 100% !important;
  object-fit: cover;
}
.video-image-wrapper {
  height: 100% !important;
}
@media only screen and (max-width: 992px) {
  .image-large {
  height: 250px;
}

}
</style>